import ICU from './icu/icu';
import { i18n } from './i18n';
export function initI18n({ icuOptions = {}, ...options }) {
    const { parseErrorHandler = undefined } = options;
    const icu = new ICU({
        parseErrorHandler,
        bindI18n: options.bindI18n,
        ...icuOptions,
    });
    return i18n(options, { icu });
}
//# sourceMappingURL=initI18n.js.map